<template>
  <div class="advanced-release">
    <enfold>
      <div class="advanced-release-item">
        <ul class="a-r-title">
          <li class="a-r-t flex-d-a-c" :class="{ activate: activate === item.key }" v-for="item in artList"
            :key="item.key" @click="setActivate(item.key)">
            <div>
              <img :src="imgRequest(item.img)" alt style="width: 128px;height: 128px;" />
            </div>
            <span style="text-align: center;">{{ $t(item.val) }}</span>
          </li>
        </ul>
        <div class="a-r-info">
          <component :is="artList.find(ar => ar.key === activate).component" />
        </div>
      </div>
    </enfold>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'

import loops from './children/Loops'
import timercom from './children/Timercom'
import Timerplay from './children/Timerplay'
import urgency from './children/Urgency'

const artList = [
  { key: '1', val: 'aci1', i18n: '', img: 'LoopsPlaying.png', component: 'loops', arItem: 'LoopsItem' },
  { key: '0', val: 'aci2', i18n: '', img: 'TimerPlaying.png', component: 'timerplay', arItem: 'TmerplayItem' },
  { key: '2', val: 'aci3', i18n: '', img: 'UrgencyPlaying.png', component: 'urgency', arItem: 'UrgencyItem' },
  { key: '3', val: 'aci4', i18n: '', img: 'RealTimeCommand.png', component: 'timercom', arItem: 'TimercomItem' },
];

export default {
  name: "advancedRelease",
  data() {
    return {
      artList,
      activate: '1',
    }
  },
  created() {
  },
  methods: {
    setActivate(type) {
      this.activate = type;
    },
    imgRequest(img) {
      return require("@/components/advancedRelease/children/image/" + img);
    },
  },
  components: {
    enfold,
    loops,
    timercom,
    Timerplay,
    urgency,
  }
}
</script>

<style lang="scss" scoped>
.advanced-release {
  width: 100%;
  height: 100%;
  // background-color: #edfbff;

  .advanced-release-item {
    width: 100%;
    height: 100%;
    display: flex;
    background-color: #edfbff;

    /* .a-r-top-t {
      height: 40px;
      line-height: 40px;
      text-align: center;
    } */

    .a-r-title {
      width: 160px;
      min-width: 160px;
      border-radius: 8px;
      background: #fff;
      margin-right: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      border: 1px solid #409EFF;
      overflow-y: auto;

      .a-r-t {
        width: 128px;
        height: 168px;
        border-radius: 8px;
        border: 2px solid #409EFF;
        cursor: pointer;
        user-select: none;
        margin: 16px 0px;
      }

      .a-r-t:hover {
        background-color: #edfbff;
      }
    }

    .a-r-info {
      flex-grow: 1;
    }

    .activate {
      background-color: #409EFF !important;
    }
  }
}
</style>
